import {HTTP} from "../../../libs/HTTP";

class AuthApi {

    login(username, password) {
        return HTTP.post("/api/auth/signin", {    
            username: username,
            password:password

        })
        .then(response => response.data);
    }

    login__(username, password) {

        const formData = new FormData();
        formData.append("grant_type", "password");
        formData.append("username", username);
        formData.append("password", password);
        formData.append("client_id", "ui-react-client");

        // return HTTP.post( '/account/oauth/token',
        return HTTP.post( '/api/auth/signin',
            formData,
            {
                headers: {
                    'Content-Type': 'application/json' //'application/x-www-form-urlencoded'
                }
            }
        ).then(response => {
            console.log(response);
            return response.data;
        })

        .catch(function(){
            console.log('FAILURE!!');
        });
    }

    register(username, email, password) {
        
//        const formData = new FormData();
//        formData.append("grant_type", "password");
//        formData.append("client_id", "ui-react-client");
//        formData.append("username", username);
//        formData.append("password", password);
//        formData.append("matchingPassword", password);
//        formData.append("email", email);
//        
//        return HTTP.post( '/account/signup',
//            formData,
//            {
//                headers: {
//                    'Content-Type': 'application/x-www-form-urlencoded',
//                }
//            }
//        ).then(response => {
//            console.log(response);
//            return response.data;
//        })
//
//        .catch(function(){
//            console.log('FAILURE!!');
//        });
        
        // return HTTP.post("/account/signup", {
        return HTTP.post("/api/auth/signup", {  
            username: username,
            email: email,
            password:password,
            "grant_type": "password",
            "client_id": "ui-react-client"
        })
        .then(response => response.data);
    }

}
const authApi = new AuthApi();
export default authApi;